module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/293.cd119af9.png";